export enum ButtonTypeEnum {
  BASIC = 'basic',
  OUTLINE = 'outline',
  SUCCESS = 'success',
  PRIMARY = 'primary',
  WARNING = 'warning',
  DANGER = 'danger',
}
